import {ZITI_DATA_SERVICE, ZitiDataService, ExtensionService, GrowlerService} from "ziti-console-lib";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  OnChanges,
  SimpleChanges,
  Inject,
  ViewChild,
} from '@angular/core';
import {isEmpty, cloneDeep, unset} from 'lodash';
import _ from 'lodash';
import {ActivatedRoute, Router, NavigationEnd} from "@angular/router";
import {Location} from "@angular/common";
import { HttpShare } from '@netfoundry-ui/shared/model';
import { ApiService, LoggerService, NamespaceService, AgentService, ShareService, AuthProviderService, HealthCheckService } from "@netfoundry-ui/shared/services";

import { Subscription, Subject } from "rxjs";
import { GrowlerData } from "@netfoundry-ui/shared/growler";
import { RxTxSample } from '@netfoundry-ui/ui/rx-tx-timeline-chart';

@Component({
    selector: 'app-http-share-form',
    templateUrl: './http-share-form.component.html',
    styleUrls: ['./http-share-form.component.scss'],
    standalone: false
})
export class HttpShareFormComponent implements OnInit, OnChanges {
  @Input() isModal = false;
  @Input() formData: any = {};
  close: EventEmitter<any> = new EventEmitter<any>();

  isEditing = false;

  formView = 'simple';

  errMap:  any = {};
  timeout = Date.now() + 10 * 60 * 1000;

  saveSubject = new Subject<boolean>;
  mappingConfigUpdateSubject = new Subject<boolean>;

  moreActions: any[] = [];
  protected isLoading = false;
  initData: any = {};
  @Output() dataChange: EventEmitter<any> = new EventEmitter<any>();
  _dataChange = false;
  isV2 = true;
  hideMetrics = false;
  showHealthChecks = false;
  public errors: any = {};
  basePath = '';
  previousRoute;
  healthCheckLabel;
  authProviderLabel;
  hideAuthSelection = false;
  showHealthCheckLabel = false;
  showAuthLabel = false;
  namespace;
  errorState = false;
  protected usePreviousLocation = true;
  subscription: Subscription = new Subscription();
  @Input() entityId: string;
  baseHref: any;
  formInit = false;
  frontdoorId: string;
  agentList;
  namespaceList;
  providerList;
  hideNamespaceItem = false;
  agentError = false;
  IngressPortError = false;
  nameError = false;
  targetError = false;
  namespaceError = false;
  namespaceErrorMessage;
  agentErrorMessage;
  IngressPortMessage;
  nameErrorMessage;
  targetErrorMessage;
  healthChecks = [];


  metricSamples: RxTxSample[] = [];
  metricsLoading = false;

  processing = false;
  constructor(
      private apiService: ApiService,
      public agentService: AgentService,
      private logger: LoggerService,
      public svc: ShareService,
      public namespaceService: NamespaceService,
      public shareService: ShareService,
      public authProviderService: AuthProviderService,
      public healthCheckService: HealthCheckService,
      private growlerService: GrowlerService,
      @Inject(ZITI_DATA_SERVICE) protected zitiService: ZitiDataService,
      private location: Location,
      protected router?: Router,
      protected route?: ActivatedRoute,
  ) {
    this.previousRoute = router?.getCurrentNavigation()?.previousNavigation?.finalUrl?.toString();
        this.subscription.add(
            this.route?.params?.subscribe(params => {
                const id = params['id'];
                if (isEmpty(id)) {
                    this.entityId = 'create';
                } else {
                  this.entityId = id;
                }
            })
        );
        this.subscription.add(
            router?.events.subscribe((event: any) => {
                  if (!event?.snapshot?.routeConfig?.path) {
                      return;
                  }
                  const pathSegments = event.snapshot.routeConfig.path.split('/');
                  this.basePath = pathSegments[0];

            })
        );
        this.initBaseHref();
  }

  ngOnInit(): void {
      this.subscription.add(
          this.apiService.currentTenant.subscribe((tenant) => {
              this.agentService.getAccountById(tenant.id).subscribe((frontdoor: any) => {
                  this.frontdoorId = frontdoor.id;
                  if (this.entityId === 'create') {
                      this.formData = new HttpShare();
                      this.initData = cloneDeep(this.formData);
                      this.entityUpdated();
                      this.getAgents()
                      this.getAuthProviders();
                      this.getNamespaces()
                      return;
                  } else {
                      this.isEditing = true;
                      this.isLoading = true;
                      this.getHttpShare();
                      this.getAgents();
                      this.getAuthProviders();
                      this.getNamespaces()
                  }
              })
          })
      );
      this.formInit = true;
  }


  getHttpShare() {
    return this.svc.getHttpShare(this.frontdoorId, this.entityId).subscribe({
      next: (entity: HttpShare) => {
        this.formData = entity;
        this.formData.envId = entity.envZId;
        if(!this.formData.authProviderId) {
          this.formData.authProviderId = ''
        }
        if (this.frontdoorId && this.entityId) {
          this.metricsLoading = true;
          this.agentService.getMetricsPerHttpShare(this.frontdoorId, this.entityId).subscribe({
            next: (data: any) => {
              this.metricSamples = data?.samples ?? [];
              this.metricsLoading = false;
            },
            error: () => {
              this.metricSamples = [];
              this.metricsLoading = false;
            },
          });
        }
        this.namespaceService.getSingleNamespace(this.frontdoorId, this.formData.namespaceId).subscribe((data: any) => {
          this.namespace = data.name;
        })
        this.healthCheckService.getHealthChecksByShare(this.frontdoorId, this.formData.id, this.isV2).subscribe((data: any) => {
          if (data._embedded) {
            this.showHealthCheckLabel = false;
            this.healthChecks = data._embedded.healthCheckList;
          } else {
            this.showHealthCheckLabel = true;
            this.healthCheckLabel = 'No health checks configured for this share, create one'
          }

        })

        this.initData = cloneDeep(this.formData);
        this.entityUpdated();
        this.isLoading = false;
      },
      error: (err) => {
        this.growlerService.show(
        new GrowlerData(
            'error',
            'Error',
            'Error retrieving http share data.',
        )
    );
    this.isLoading = false;
      }
    })
  }

  ngOnChanges(changes: SimpleChanges) {
    this.isEditing = !isEmpty(this.formData.id);
  }

  initBaseHref() {
        try {
            const base = document?.querySelector('base');
            this.baseHref = base ? base.getAttribute('href') : '/';
        } catch (error) {
            this.baseHref = '/';
        }
    }

  entityUpdated() {
    if (this.formData.id) {
    }

    unset(this.formData, '_links');
    this.initData = cloneDeep(this.formData);
  }

  hideMetricsAction() {
    return isEmpty(this.formData?.id);
  }

  hideHealthChecksAction() {
    return isEmpty(this.formData?.id);
  }


  headerActionRequested(action: any) {
    switch(action.name) {
      case 'save':
        this.save();
        break;
      case 'close':
        this.closeForm();
        break;
      case 'toggle-view':
        this.formView = action.data;
        break;
    }
  }

      getAgents() {
        this.agentService.getAgentsByEnv(this.frontdoorId, true).subscribe((agents: any) => {
            this.agentList = agents._embedded.environmentList;
        })
    }

        getNamespaces() {
        this.namespaceService.getNamespaces(this.frontdoorId).then((data: any) => {
            if(data._embedded) {
            this.namespaceList = data?._embedded?.namespaceList;
            } else {
                this.hideNamespaceItem = true;
            }

        })
    }


save(event?: any) {
  this.processing = true;
  this.isLoading = true;
  if(this.formData.authProviderId === '') {
    _.set(this.formData, 'authProviderId', null)
  }

  const proms = [];

  // 1. Handle Subject logic for Editing mode
  if (this.isEditing) {
    this.saveSubject.next(true);
    const updateSubjectPromise = new Promise<boolean>((resolve) => {
      // Note: Consider taking(1) so this doesn't hang
      this.mappingConfigUpdateSubject.asObservable().subscribe((wasUpdated: boolean) => {
        resolve(wasUpdated);
      });
    });
    proms.push(updateSubjectPromise);
  } else {
    // If not editing, we push 'true' so the Promise.all logic stays consistent
    proms.push(Promise.resolve(true));
  }

  // 2. Branch between Create and Update
  // We wrap the observable in toPromise() or use a new Promise wrapper
  // so Promise.all can actually track it.
  const httpCall = this.isEditing
    ? this.svc.updatehttp(this.frontdoorId, this.formData,  this.formData.id)
    : this.svc.createhttp(this.frontdoorId, this.formData );

  const requestPromise = new Promise((resolve, reject) => {
    httpCall.subscribe({
      next: (result: any) => {
        if (this.isModal) {
          this.closeModal(true, true);
        } else {
          this.initData = this.formData;
          this.formData = result;
          this._dataChange = false;
          this.isLoading = false;
          this.returnToListPage()
        }
        resolve(true);
      },
      error: (err) => {
        this.processErrors(err);
        this.isLoading = false;
      }
    });
  });

  proms.push(requestPromise);

  // 3. Finalize
  Promise.all(proms)
    .then((results) => {
      // results[0] is the Subject, results[1] is the HTTP call
      if (results[0] === true && results[1] === true) {
        this.returnToListPage();
        // TODO: Success message
      }
    })
    .catch(err => {
      // Handle errors here
    })
    .finally(() => {
      this.processing = false;
      this.isLoading = false;
    });
}

  validate() {
    this.errMap = {};
    if (isEmpty(this.formData.name)) {
      this.errMap['nameRequired'] = true;
    }

    return isEmpty(this.errMap);
  }

      copyText(text: string) {
  navigator.clipboard.writeText(text).then(() => {
        this.growlerService.show(
        new GrowlerData(
            'success',
            'Success',
            'Copied to clipboard',
             text + ' has been copied to your clipboard'
        )
        );
    });
    }


  clear(): void {
  }

    showMetricsModal() {
      this.hideMetrics = !this.hideMetrics;
      const action = this.moreActions.find(a => a.name === 'hideMetrics');
      if (action) {
        action.label = this.hideMetrics ? 'Show Metrics' : 'Hide Metrics';
      }
    }


    toggleInsecure() {
        this.formData.insecure = !this.formData.insecure;

    }

        onKeyDown(event: KeyboardEvent) {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            event.stopPropagation();
            const element = event.target as HTMLElement;
            element.blur();
            element.focus();
        }
    }


    getAuthProviders() {
        this.authProviderService.getAuthProviders(this.frontdoorId, this.isV2).subscribe((data: any) => {
          if(data._embedded) {
            const providers = data?._embedded?.authProviderList;
            this.providerList = [
                { id: '', name: 'None / No Provider' },
                ...providers
            ];
          } else {
            this.showAuthLabel = true;
            this.authProviderLabel = 'No authentication providers configured for your frontdoor account, create one'
          }

        })
    }

  closeModal(refresh = true, ignoreChanges = false, data?: any, event?: any): void {
    this.close.emit({refresh: refresh});
    if (event) {
        event.stopPropagation();
    }
  }



  closeForm(refresh = true, ignoreChanges = false, data?, event?) {
      if (!ignoreChanges && this._dataChange) {
          const confirmed = confirm('You have unsaved changes. Do you want to leave this page and discard your changes or stay on this page?');
          if (!confirmed) {
              return;
          }
      }
      if (this.isModal) {
          this.closeModal(refresh, ignoreChanges);
      } else {
          this.returnToListPage();
      }
  }

  returnToListPage() {
      this.router?.navigateByUrl(`${this.basePath}/http-shares`);
  }


    processErrors(errorResponse: any) {
            const errors: string[] = errorResponse?.error?.errors || [];
            const envZIdError = errors.find(e => e.includes('envZId'));
            const targetError = errors.find(e => e.includes('target'));
            const nameError = errors.find(e => e.includes('name'));
            const namespaceError = errors.find(e => e.includes('namespace'));
            const acrossAccountError = errorResponse?.status === 409
            const nameTooShortError = errorResponse?.status === 422
            if(envZIdError) {
                this.agentError = true;
                this.agentErrorMessage =  envZIdError.split(':').slice(1).join(':').trim();
            }
            if(targetError) {
                this.targetError = true;
                this.targetErrorMessage =  targetError.split(':').slice(1).join(':').trim();
            }
            if(nameError) {
                this.nameError = true;
                this.nameErrorMessage =  nameError;
            }
            if(namespaceError) {
                this.namespaceError = true;
                this.namespaceErrorMessage =  namespaceError.split(':').slice(1).join(':').trim();
            }

            if(acrossAccountError) {
                           this.growlerService.show(
                        new GrowlerData(
                            'error',
                            'TCP Share create request failed',
                            errorResponse?.error?.detail
                    )
            );
            }
            if(nameTooShortError) {
                           this.growlerService.show(
                        new GrowlerData(
                            'error',
                            'TCP Share create request failed',
                            'Share name but be more than 4 characters.'
                    )
            );
            } else {
                this.growlerService.show(
                        new GrowlerData(
                            'error',
                            'TCP Share create request failed',
                            'Share create request has failed.'
                    )
            );
            }

}


  mappingConfigUpdateHandler(wasUpdated: boolean) {
    this.mappingConfigUpdateSubject.next(wasUpdated);
  }




    /**
     * True when this form is showing an existing entity. Derived from the route/input
     * rather than the loaded record, so the header title doesn't briefly read
     * "Create New ..." while the record is still being fetched.
     */
    get isExistingEntity(): boolean {
        return !isEmpty(this.formData?.id) || (!isEmpty(this.entityId) && this.entityId !== 'create');
    }

}
